import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import Dropdown from "react-bootstrap/Dropdown";
import camelCase from "lodash/camelCase";
import Tooltip from "@edaz/edazkit/Tooltip";
import type BalanceViewModel from "viewModels/finance/accountingInventory/balance/balanceViewModel";
import type AccountBalanceCheckRequestResponse from "entities/accountBalanceCheckRequestResponse";

export interface BalanceMenuProps {
  vm: BalanceViewModel;
  checkRequest: AccountBalanceCheckRequestResponse;
}

const BalanceMenu: FunctionComponent<BalanceMenuProps> = observer((props: BalanceMenuProps) => {
  const { vm, checkRequest } = props;

  return (
    <Dropdown drop="left">
      <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
        ⋮
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight={true}>
        {vm.actions(checkRequest).map(action => {
          const permittedAction = vm[`allowTo${action}`](checkRequest);
          let content: React.ReactNode = vm.translate(`actions.${camelCase(action)}.name`);
          if (!permittedAction.isAllowed) {
            content = (
              <Tooltip id={`balance-${checkRequest.id}-${action}`} tooltip={vm.disabledActionTooltip(action, checkRequest)}>
                <span>{content}</span>
              </Tooltip>
            );
          }

          return (
            <Dropdown.Item
              key={action}
              disabled={!permittedAction.isAllowed}
              onClick={() => vm[`on${action}Click`](checkRequest)}
              style={{ pointerEvents: "auto" }}>
              {content}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default BalanceMenu;
